import { Play } from '@styled-icons/remix-fill';

import * as S from './styles';

export type PlayButtonProps = {
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'inverted';
  size?: 'small' | 'medium' | 'large';
};

const PlayButton = ({
  onClick,
  size = 'medium',
  variant = 'primary',
}: PlayButtonProps) => {
  return (
    <S.ButtonContainer>
      <S.ButtonHighlight size={size} variant={variant}>
        <S.Button
          variant={variant}
          size={size}
          onClick={onClick}
          aria-label="Play video"
          type="button"
        >
          <S.Play variant={variant} size={size}>
            <Play />
          </S.Play>
        </S.Button>
      </S.ButtonHighlight>
    </S.ButtonContainer>
  );
};

export default PlayButton;
